// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DeleteWidgetHostConfigRequestModel from '../../model/delete-widget-host-config-request-model';
import DeleteWidgetHostConfigRequestDTO from '../dto/delete-widget-host-config-request-dto';
import dtoSchema from '../schemas/delete-widget-host-config-request-schema';

export default abstract class DeleteWidgetHostConfigRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DeleteWidgetHostConfigRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int32}
  */
  id?: number;

  static toModel(dto: DeepPartial<DeleteWidgetHostConfigRequestDTO>): DeleteWidgetHostConfigRequestModel;
  static toModel(dto: DeepPartial<DeleteWidgetHostConfigRequestDTO> | undefined | null): DeleteWidgetHostConfigRequestModel | undefined;
  static toModel(dto: DeepPartial<DeleteWidgetHostConfigRequestDTO> | undefined | null): DeleteWidgetHostConfigRequestModel | undefined {
    return dto ? new DeleteWidgetHostConfigRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DeleteWidgetHostConfigRequestModel> | DeleteWidgetHostConfigRequestModel): DeleteWidgetHostConfigRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as DeleteWidgetHostConfigRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DeleteWidgetHostConfigRequestModel, can not map to DeleteWidgetHostConfigRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
